'use client';
import Link from 'next/link';
import { FaXmark } from 'react-icons/fa6';

import CartButton from '@/features/home/Flash_sales/components/CartButton';
import NextImage from '@/features/Image';
import { FaRegTrashAlt } from 'react-icons/fa';

const WishlistRow = ({
  product,
  removeProduct,
}: {
  product: any;
  removeProduct: any;
}) => {
  return (
    <>
      <div className="cart d-flex align-items-center gap-3">
        {/* Product Image */}
        <div className="flex-shrink-0">
          <Link href="#">
            <NextImage
              width={80}
              height={80}
              src={product.product.thumbnail_image}
              alt={'wishlist image'}
              className="img-fluid rounded"
            />
          </Link>
        </div>

        {/* Product Info */}
        <div className="flex-grow-1 w-100 product-info__wrapper">
          <div className="d-flex justify-content-between align-items-start custom-width">
            <h6 className="mb-0 product-title1">
              <Link
                href={
                  product.product?.slug
                    ? `/product/${product.product?.slug}`
                    : '/shop'
                }
              >
                {product.product.name}
              </Link>
            </h6>
            <div className="d-lg-none">
              <CartButton isIcon={true} product={product?.product} />
            </div>
          </div>

          {/* For desktop view */}
          <div className="d-none d-lg-block">
            <div className="d-flex justify-content-between align-items-lg-center gap-2 gap-md-5 flex-wrap">
              {/* Unit Price */}
              <div>
                <span className="fw-semibold text-muted">Price:</span>{' '}
                {product.product.sale_price}
              </div>

              {/* Quantity Control */}
              <div className="d-flex">
                <CartButton isIcon={true} product={product?.product} />
              </div>

              {/* Remove Button (desktop only) */}
              <div className="cart__delete d-none d-lg-block order-md-4">
                <span
                  onClick={() => removeProduct(product?.product?.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <FaXmark />
                </span>
              </div>
            </div>
          </div>

          {/* For mobile view */}
          <div className=" d-lg-none w-100">
            <div className="d-flex justify-content-between align-items-center mt-2 gap-2 md-gap-5 flex-wrap">
              {/* Unit Price */}
              <div>
                <span className="fw-semibold text-muted">Price:</span>{' '}
                {product.product.base_price}
              </div>

              <span
                className={`fs-small ${product?.product?.stock > 0 ? 'text-success' : 'text-danger'}`}
              >
                {product?.product?.stock > 0 ? 'In stock' : 'Out of stock'}
              </span>

              <div>
                <span
                  onClick={() => removeProduct(product?.product?.id)}
                  className="text-danger p-1"
                  style={{ cursor: 'pointer' }}
                >
                  <FaRegTrashAlt />
                </span>
              </div>

              {/* Remove Button (desktop only) */}
              <div className="d-none d-lg-block order-md-4">
                <span
                  onClick={() => removeProduct(product?.product?.id)}
                  className="text-danger"
                  style={{ cursor: 'pointer' }}
                >
                  <FaRegTrashAlt />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WishlistRow;
